import React from 'react';

import { DeviceActionProps } from './DeviceActions';
import { ListItemIcon, useTheme } from '@mui/material';
import {
  UserInterfaceIcon,
  UserInterfaceOffIcon,
} from '../../../../../../theme/icons';
import { UtilInstance } from '../../../../../../util/Util';
import { getPolyglot } from '../../../../../../i18n';
import { useAppSelector } from '../../../../../../redux/store.model';
import {
  ButtonIcon,
  MenuItemPrimary,
} from '../../../../../../theme/components';
import DeviceModel from '../../../../../../redux/commander/api/DeviceModel';
import useCommanderStatus from '../../../../../../redux/commander/commander-status/hooks/useCommanderStatus';

const iconId = 'interface';
const icon = <UserInterfaceIcon height={'1em'} />;
const iconOff = <UserInterfaceOffIcon height={'1.4em'} color="inherit" />;
const iconGrid = <UserInterfaceIcon height={'1em'} />;
const proxyBackendURL = UtilInstance.getCommanderProxyURL();

export function DeviceUIAction(props: DeviceActionProps) {
  const { device, groupId, variant } = props;
  const polyglot = getPolyglot();
  const accessToken = useAppSelector((state) => state.auth.accessToken);

  const tooltipContent = polyglot.t('device.tooltip.open_window_ui');

  const openDeviceUI = (e: React.MouseEvent) => {
    const deviceRedirectURL = `${proxyBackendURL}/${device?.ip}/?token=${accessToken}`;
    window.open(deviceRedirectURL, '_blank');
  };

  // Device status
  const { commanderStatus, isLoading: loadingCommanderStatus } =
    useCommanderStatus(device.uuid);
  const cloudConnectivityStatus = new DeviceModel().cloudConnectivityStatus(
    device?.lastPing,
    commanderStatus
  );
  const theme = useTheme();

  return variant === 'menuItem' ? (
    <MenuItemPrimary
      onClick={openDeviceUI}
      className={`icon-${iconId} group-${groupId}`}
      disabled={!cloudConnectivityStatus.cloudConnectivityVPN}
    >
      <ListItemIcon sx={{ color: 'inherit' }}>
        {cloudConnectivityStatus.cloudConnectivityVPN ? iconGrid : iconOff}
      </ListItemIcon>
      {tooltipContent}
    </MenuItemPrimary>
  ) : (
    <ButtonIcon
      className={`icon-${iconId} group-${groupId}`}
      tooltip={tooltipContent}
      onClick={openDeviceUI}
      disabled={!cloudConnectivityStatus.cloudConnectivityVPN}
      loading={device.loadingData || loadingCommanderStatus}
      sx={{ width: '45px', height: '45px' }}
    >
      {cloudConnectivityStatus.cloudConnectivityVPN ? (
        icon
      ) : (
        <div style={{ color: theme.palette.grey.A100, marginTop: '20px' }}>
          {iconOff}
        </div>
      )}
    </ButtonIcon>
  );
}

export default DeviceUIAction;
